/**
 * @author Matthew Rogers.
 */
var close_reasonBind = { parent: '=' };
var CloseReasonSelectController = (function () {
    function CloseReasonSelectController(socket, $scope, env, admin) {
        var _this = this;
        this.socket = socket;
        this.$scope = $scope;
        this.env = env;
        this.admin = admin;
        this.codesLoaded = false;
        //declare listener for response from the service
        this.socket.forward('config.misc_codes_by_type', this.$scope);
        this.$scope.$on('socket:config.misc_codes_by_type', function (event, data) {
            if (angular.isDefined(data)) {
                _this.reasonCodes = data;
                _this.codesLoaded = true;
            }
        });
    }
    CloseReasonSelectController.prototype.$onInit = function () {
        this.admin.getMiscCodesByType('closed_codes');
    };
    CloseReasonSelectController.$inject = ['socket', '$scope', 'env', 'admin'];
    return CloseReasonSelectController;
}());
var CloseReasonSelectComponent = (function () {
    function CloseReasonSelectComponent() {
        this.templateUrl = 'close-reason-select.html';
        this.bindings = close_reasonBind;
        this.controller = CloseReasonSelectController;
    }
    return CloseReasonSelectComponent;
}());
angular
    .module('application')
    .component('closeReasonSelect', new CloseReasonSelectComponent());

//# sourceMappingURL=close-reason-select.component.js.map
